import Flickity from 'flickity';
import 'flickity-imagesloaded';
import { max } from 'lodash-es';
import { SliderCartItem } from './SliderCartItem';

let monetateMobileListenerInitialized = false;
let flickityMobileInstance = null;

export function SliderCartAddonsMobile() {
  const container = document.createElement('div');
  container.className = 'SliderCartAddOnsContainer SliderCartAddOnsContainer--mobile';

  const carouselWrapper = document.createElement('div');
  carouselWrapper.className = 'SliderCartAddonsMobile';
  container.appendChild(carouselWrapper);

  const carouselOptions = {
    imagesLoaded: true,
    cellAlign: 'left',
    contain: true,
    draggable: true,
    dragThreshold: 10,
    initialIndex: 0,
    prevNextButtons: false,
    pageDots: false,
  };

  function handleLoad(event) {
    const items = event.detail.monetateData;
    const title = event.detail.title;

    if (flickityMobileInstance && typeof flickityMobileInstance.destroy === 'function') {
      flickityMobileInstance.destroy();
      flickityMobileInstance = null;
    }

    carouselWrapper.innerHTML = '';

    const prevHeading = container.querySelector('.SliderCartAddOns__headings');
    if (prevHeading) prevHeading.remove();

    // Ensure carousel wrapper is in the container
    if (!container.contains(carouselWrapper)) {
      container.appendChild(carouselWrapper);
    }

    if (title?.trim()) {
      const heading = document.createElement('div');
      heading.className = 'SliderCartAddOns__headings';
      const h2 = document.createElement('h2');
      h2.textContent = title;
      heading.appendChild(h2);
      container.insertBefore(heading, carouselWrapper);
    }

    if (!items || items.length === 0) return;

    items.forEach((item) => {
      const firstVariant = item.Child_Attributes?.[0];
      if (!firstVariant) return;

      const comparePrices = item.Child_Attributes.map((v) => v.compare_at_price);
      const comparePriceMax = max(comparePrices);

      const variantsWithAvailability = item.Child_Attributes.map((variant) => {
        const available = variant.available || false;
        return { ...variant, available };
      });

      const productUrl = item.Detail_URL.replace('https://windsor-us.myshopify.com', '');

      const tileProps = {
        id: item.item_group_id,
        pid: item.ID,
        title: item.Title,
        product_url: productUrl,
        thumb_url: firstVariant.image_url,
        thumb_alt: item.Title,
        price: firstVariant.price,
        price_compare: firstVariant.compare_at_price,
        price_compare_max: comparePriceMax,
        tags: item.tags.split(','),
        variants: variantsWithAvailability,
        product: item,
        options: item.options,
        colorOptions: item.color,
        sizeOptions: item.size,
        isRec: true,
        selectedColor: item.selectedColor,
      };

      const tile = SliderCartItem(tileProps);
      if (tile) carouselWrapper.appendChild(tile);
    });

    flickityMobileInstance = new Flickity(carouselWrapper, carouselOptions);
  }

  if (!monetateMobileListenerInitialized) {
    document.addEventListener('monetateLoadedcart1_rr', handleLoad);
    document.addEventListener('monetateLoadedemptycart1_rr', handleLoad);
    monetateMobileListenerInitialized = true;
  }

  return container;
}
